const env = process.env.NODE_ENV;
export default require(`./${env}.json`);